// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__32_-a","show":"Modal__show__2I0kq","Error":"Modal__Error__-vTWh","Success":"Modal__Success__3c_8r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 134
// module chunks = 0